import { Haptics, ImpactStyle, NotificationType } from "@capacitor/haptics";
import { ClaimKind } from "./goalClaims";
import {
    assistSound,
    goalSound,
    hatTrickSound,
    refusedSound,
    releasedSound,
    splashSound,
} from "./claimSounds";

// Success pattern under a Save splash
export const splashHaptic = () => {
    splashSound();
    return Haptics.notification({ type: NotificationType.Success });
};

/**
 * The buzz for a claim (SCORZA-110): an assist is a light tap, goals hit
 * harder as they add up, and a hat-trick or claiming every goal gets the
 * success pattern. Each buzz has a quiet sound started with it, in sync.
 */
export const claimHaptic = (
    kind: ClaimKind,
    goalsAfter: number,
    allClaimed: boolean
) => {
    if (allClaimed || (kind === "goals" && goalsAfter >= 3)) {
        hatTrickSound();
        return Haptics.notification({ type: NotificationType.Success });
    }
    if (kind === "assists") {
        assistSound();
        return Haptics.impact({ style: ImpactStyle.Light });
    }
    goalSound(goalsAfter);
    return Haptics.impact({
        style: goalsAfter >= 2 ? ImpactStyle.Heavy : ImpactStyle.Medium,
    });
};

// Claim pressed with every goal already claimed
export const claimRefusedHaptic = () => {
    refusedSound();
    return Haptics.notification({ type: NotificationType.Warning });
};

export const claimReleasedHaptic = () => {
    releasedSound();
    return Haptics.impact({ style: ImpactStyle.Light });
};
